/**
 * SEO AB 分桶：id hash 后对 100 取模，保证 50% / 25% / 25%。
 * 0–49 对照；50–74 SEO 标题；75–99 SEO 摘要。
 */
const SEO_AB_BUCKET_SIZE = 100;

const hashIdToSeoAbValue = (text) => {
    let hash = 0;
    const str = String(text);

    for (let i = 0; i < str.length; i++) {
        hash = (Math.imul(hash, 31) + str.charCodeAt(i)) >>> 0;
    }

    return hash % SEO_AB_BUCKET_SIZE;
};

const normalizeSeoAbNum = (seoAbValue) => {
    if (seoAbValue === null || seoAbValue === undefined || seoAbValue === '') {
        return NaN;
    }

    return Number(seoAbValue);
};

const isSeoAbTitleBucket = (seoAbValue) => {
    const n = normalizeSeoAbNum(seoAbValue);

    return Number.isFinite(n) && n >= 50 && n <= 74;
};

const isSeoAbSummaryBucket = (seoAbValue) => {
    const n = normalizeSeoAbNum(seoAbValue);

    return Number.isFinite(n) && n >= 75 && n <= 99;
};

/**
 * SEO A/B 标题与摘要展示值（逻辑对齐 H5 article）
 */
const getSeoAbDisplay = ({ title = '', seoAbValue, seoTitle, seoDescription, quanPlugin, type } = {}) => {
    const articleTitle = isSeoAbTitleBucket(seoAbValue) && seoTitle ? seoTitle : title;
    const isQuanRelate = quanPlugin && quanPlugin !== '{}';
    let articleSummary = isSeoAbSummaryBucket(seoAbValue) && seoDescription ? seoDescription : '';

    if (
        !articleSummary ||
        isQuanRelate ||
        articleSummary === title ||
        articleSummary === seoTitle ||
        type === 'short'
    ) {
        articleSummary = '';
    }

    return { articleTitle, articleSummary };
};

module.exports = {
    SEO_AB_BUCKET_SIZE,
    hashIdToSeoAbValue,
    isSeoAbTitleBucket,
    isSeoAbSummaryBucket,
    getSeoAbDisplay,
};
